import { TaskKindEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { AssignationsType, FieldNames } from 'routes/Task/enums';

const getEmptyDefaultValues = (values?: Values): Values => ({
  // step 1
  [FieldNames.taskName]: '',
  [FieldNames.taskDescription]: '',
  [FieldNames.priority]: undefined,
  [FieldNames.site]: undefined,
  [FieldNames.template]: undefined,
  [FieldNames.templateVersion]: undefined,
  [FieldNames.documentationLinks]: [],
  [FieldNames.assignationsType]: { value: AssignationsType.Area },
  [FieldNames.siteArea]: undefined,
  [FieldNames.asset]: undefined,
  [FieldNames.approver]: undefined,
  // step 2
  [FieldNames.taskKind]: { value: TaskKindEnum.Standard },
  [FieldNames.deadlineAt]: '',
  [FieldNames.earlyCompletionType]: undefined,
  [FieldNames.recurringRuleEnabled]: false,
  [FieldNames.earlyCompletionEnabled]: false,
  [FieldNames.earlyCompletionAmount]: 1,
  [FieldNames.endRepeatEnabled]: false,
  [FieldNames.repeatMonthlyRepeatOnOptions]: [],
  [FieldNames.repeatYearlyRepeatOnOptions]: [],
  // Custom
  ...values,
  // Custom renders
  [FieldNames.taskDetails]: null,
  [FieldNames.templateTitle]: null,
  [FieldNames.templateVersionViewBtn]: null,
  [FieldNames.assignationsTitle]: null,
  [FieldNames.assignationsTypeDesc]: null,
  [FieldNames.tasksDetails]: null,
  [FieldNames.scheduleTask]: null,
  [FieldNames.scheduleMessage]: null,
});

export default getEmptyDefaultValues;
